<div id="orders" class="page-layout carded fullwidth">
    <div class="top-bg primary"></div>
    <!-- CENTER -->
    <div class="center" fusePerfectScrollbar>

        <!-- HEADER -->
        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutGap="20px" fxLayoutAlign.gt-xs="space-between center">

            <!-- APP TITLE -->
            <div class="mat-display-1 my-0 my-sm-24 welcome-message" fxLayout="row" fxLayoutAlign="start center">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'USER_LIST' |translate}}</span>
            </div>
            <!-- / APP TITLE -->
            <div class="search-wrapper  ml-sm-32">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon>search</mat-icon>
                    <input #filter [(ngModel)]="filterText" placeholder="{{'SEARCH' | translate}}">
                </div>
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px grid">
                <div fxFlex>
                    <button (click)="refresh()" mat-raised-button>
                        <mat-icon>refresh</mat-icon>
                    </button>
                </div>
                <div fxFlex>
                    <button mat-raised-button (click)="addUser()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <!-- / HEADER -->

        <div class="content-card my-16" style="justify-content: space-between;">
            <div class="p-20">
                <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px;" #table
                    [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}" matSortActive="name"
                    matSortDirection="asc" fusePerfectScrollbar>

                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'NAME'|translate}}
                            {{'SURNAME'|translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            {{user.name!=null?user.name:'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="title">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'TITLE'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            {{user.title!=null?user.title:'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="userName">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'USERNAME'|translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            {{user.userName!=null?user.userName:'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="picture">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'PICTURE'|translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            <img *ngIf="user.picture" class="avatar" [src]="appConfigService.apiConfig['api-url']+'user/'+user.picture" alt="">
                            <mat-icon *ngIf="!user.picture" class="avatar">person</mat-icon>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="role">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'ROLE'|translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            <span *ngIf="user.role == -1">{{'SUPER_ADMIN'|translate}}</span>
                            <span *ngIf="user.role == 0">{{'MANAGER'|translate}}</span>
                            <span *ngIf="user.role == 1">{{'DRIVER'|translate}}</span>
                            <span *ngIf="user.role == 2">{{'PERSONEL'|translate}}</span>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="active">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'STATUS'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            {{user.active==0?('PASSIVE'|translate):('ACTIVE'|translate)}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="setting">
                        <mat-header-cell *matHeaderCellDef>{{'SETTINGS'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let userby">
                            <button *ngIf="userby.role!=-1 && userby.id!=userId" mat-icon-button
                                [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                                <mat-icon>settings</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="updateUser(userby)">
                                    <mat-icon>edit</mat-icon>
                                    <span>{{'UPDATE'|translate}}</span>
                                </button>
                                <button mat-menu-item (click)="deleteUser(userby)">
                                    <mat-icon>delete</mat-icon>
                                    <span>{{'DELETE'|translate}}</span>
                                </button>
                            </mat-menu>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let user; columns: displayedColumns;" class="order" matRipple>
                    </mat-row>
                </mat-table>
                <mat-paginator #paginator [length]="paginator.length" [pageSize]="10" [pageSizeOptions]="[10, 50, 100]">
                </mat-paginator>
            </div>
        </div>
    </div>
    <!-- / CENTER -->
</div>